import { render } from "./SurveyStatus.vue?vue&type=template&id=5c399a75"
import script from "./SurveyStatus.vue?vue&type=script&lang=js"
export * from "./SurveyStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__